// extracted by mini-css-extract-plugin
module.exports = {"taskHeaderSmall":"TaskHeaderSmall_taskHeaderSmall__1p9Qn","titleButton":"TaskHeaderSmall_titleButton__3aQYu"};